// Events
import { FEATURE_TAB_TOGGLE, MOUNT_COMPONENTS } from 'events';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';
import { hide, repaint, show } from 'utils/node';
import { dispatch } from 'utils/theme';

const initTechFeaturesSection = (ctx, node) => {
  const id = 'tech-features';

  const { videoContainer = [], video = [] } = choozy(node);

  const videoContainers = [].concat(videoContainer);
  const videos = [].concat(video);

  videoContainers.forEach((container) => {
    const currentVideo = container.querySelector('video');

    container.addEventListener('mouseenter', () => {
      currentVideo.currentTime = 0;
      currentVideo.play();

      container.classList.add('show');
    });

    container.addEventListener('mouseleave', () => {
      container.classList.remove('show');
    });
  });

  function playInSequence(index) {
    const currentVideo = videos[index];
    const currentContainer = videoContainers[index];

    const afterEnd = () => {
      currentVideo?.removeEventListener('ended', afterEnd);
      currentContainer?.classList.remove('show');

      if (index < videos.length) playInSequence(index + 1);
    };

    currentContainer?.classList.add('show');
    currentVideo?.removeAttribute('loop');
    currentVideo?.play();
    currentVideo?.addEventListener('ended', afterEnd);
  }

  ctx.on(FEATURE_TAB_TOGGLE, (state, sectionId) => {
    if (sectionId !== id) return;

    playInSequence(0);
  });
};

export default component((node, ctx) => {
  const { section = [], sectionToggle = [], backButton = [], tabTechFeatures } = choozy(node);

  const sections = [].concat(section);
  const sectionToggles = [].concat(sectionToggle);
  const backButtons = [].concat(backButton);

  let previousActiveSection = null;
  let activeSection = 'overview';

  ctx.on(FEATURE_TAB_TOGGLE, (state, sectionId) => {
    if (sectionId === activeSection) return;

    sectionToggles.forEach((el) => {
      el.classList[el.dataset.sectionToggle === sectionId ? 'add' : 'remove']('active');

      if (el.dataset.sectionToggle === sectionId && el.dataset.textLink)
        dispatch('pdp-click-readmore', { title: el.innerText });
    });

    if (previousActiveSection !== null) {
      const p = sections.find((s) => s.dataset.section === previousActiveSection);
      p.classList.remove('show');
      hide(p);
      repaint(p);
    }

    previousActiveSection = activeSection;
    activeSection = sectionId;

    sections.forEach((el) => {
      if (el.dataset.section === sectionId) {
        setCSSProperty(el, '--section-z', 2);
        show(el);
        repaint(el);
        el.classList.add('show', 'in-front');
      } else if (el.dataset.section === previousActiveSection) {
        setCSSProperty(el, '--section-z', 1);
        el.classList.remove('in-front');
      } else {
        setCSSProperty(el, '--section-z', 0);

        hide(el);
        el.classList.remove('show', 'in-front');
      }
    });

    backButtons.forEach((el) => {
      el.classList[sectionId === 'overview' ? 'remove' : 'add']('show');
    });
  });

  sectionToggles.forEach((toggle) => {
    const id = toggle.dataset.sectionToggle;

    toggle.addEventListener('click', () => {
      ctx.emit(FEATURE_TAB_TOGGLE, null, id);
    });

    toggle.addEventListener('mouseenter', () => {
      sectionToggles.forEach((el) => {
        const toggleId = el.dataset.sectionToggle;

        if (toggleId === id) {
          el.classList.add('hover');
        }
      });
    });

    toggle.addEventListener('mouseleave', () => {
      sectionToggles.forEach((el) => {
        el.classList.remove('hover');
      });
    });
  });

  initTechFeaturesSection(ctx, tabTechFeatures);

  document.addEventListener('shopify:block:select', (e) => {
    ctx.emit(FEATURE_TAB_TOGGLE, null, e.target.dataset.section);
  });

  document.addEventListener('shopify:section:load', () => {
    ctx.emit(MOUNT_COMPONENTS);
  });
});
